import React from 'react'
// import './parametro.css'

class Parametro extends React.Component {
    handleChange = (event) => {
        const {index, onSeleccionarParametro } = this.props
        onSeleccionarParametro(index, event.target.value)
    }

    componentDidMount() {
        // const {index, opciones, onSeleccionarParametro} = this.props
        // onSeleccionarParametro(index, opciones[0].id)
    }

    render () {
        const { titulo, opciones, index, value } = this.props
        return (
            <div className="opcionIndice">
                <span dangerouslySetInnerHTML={{ __html: titulo }} />
                { opciones.map(
                    ({id, titulo}) => <label>
                        <input type="radio" name={`parametro-${index}`} value={id} checked={ id === value } onChange={ this.handleChange } /> 
                        <span dangerouslySetInnerHTML={{ __html: titulo}} />
                    </label> 
                )}
                {/* <select onChange={ this.handleChange } value={ value }>
                    { opciones.map( ({id, titulo}) => <option key={'parametro-' + id} value={id} dangerouslySetInnerHTML={{ __html: titulo}} /> )}
                </select> */}
            </div>
        )
    }
}

export default Parametro